export default "__VITE_ASSET__VV8B$1p4__"